import { IonSpinner, IonToggle } from "@ionic/react";
import React from "react";

interface IonToggleWithSpinnerProps {
  disabled?: boolean;
  checked?: boolean;
  onChange: (checked: boolean) => Promise<void>;
}

export function IonToggleWithSpinner(props: IonToggleWithSpinnerProps) {
  const [loading, setLoading] = React.useState(false);

  const onChange = async (checked: boolean) => {
    setLoading(true);
    await props.onChange(checked);
    setLoading(false);
  };

  return (
    <>
      {loading && <IonSpinner />}
      {!loading && <IonToggle disabled={props.disabled} checked={props.checked} onIonChange={(e) => onChange(e.detail.checked)} />}
    </>
  );
}
